export const getProgramDiscountsListState = state => state.deals.programDiscountsList
